import React from 'react';
import { Container, Card } from '../design-system';
import { Cog, Timer, Handshake, Target, ShieldCheck, Rocket } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';

export function Features() {
  const { t } = useI18n();
  const features = [
    {
      icon: Cog,
      title: t('features.items.systems.title'),
      description: t('features.items.systems.desc')
    },
    {
      icon: Timer,
      title: t('features.items.integrations.title'),
      description: t('features.items.integrations.desc')
    },
    {
      icon: Handshake,
      title: t('features.items.backups.title'),
      description: t('features.items.backups.desc')
    },
    {
      icon: Target,
      title: t('features.items.delivery.title'),
      description: t('features.items.delivery.desc')
    },
    {
      icon: ShieldCheck,
      title: t('features.items.observability.title'),
      description: t('features.items.observability.desc')
    },
    {
      icon: Rocket,
      title: t('features.items.payments.title'),
      description: t('features.items.payments.desc')
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <Container maxWidth="xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            {t('features.heading')}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            {t('features.description')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card key={index} hover className="group">
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center mb-5 group-hover:bg-indigo-600 transition-colors">
                    <Icon className="w-8 h-8 text-indigo-600 group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-xl font-semibold text-slate-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-slate-600">
                    {feature.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
